import { postJson, postJsonInvoke } from './BaseSignalRDAO';

// Function to negotiate SignalR connection
export const negotiateSignalR = async (bearerToken: string) => {
  return await postJson('Negotiate_v1', {}, bearerToken);
};

export const invokeUserSRGroup = async (
  add: boolean,
  connectionId: string,
  bearerToken: string,
) => {
  return await postJsonInvoke(
    `UpdateUserSRGroup_v1?add=${add}&connection_id=${connectionId}`,
    {},
    bearerToken,
  );
};

export const invokeOrganizationSRGroup = async (
  add: boolean,
  connectionId: string,
  orgCode: string,
  bearerToken: string,
) => {
  return await postJsonInvoke(
    `UpdateOrganizationSRGroup_v1?add=${add}&connection_id=${connectionId}&org_code=${orgCode}`,
    {},
    bearerToken,
  );
};

export const invokeEmergencySRGroup = async (
  add: boolean,
  connectionId: string,
  emergencyId: string,
  bearerToken: string,
) => {
  return await postJsonInvoke(
    `UpdateEmergencySRGroup_v1?add=${add}&connection_id=${connectionId}&emergency_id=${emergencyId}`,
    {},
    bearerToken,
  );
};

export const invokeAppVersion = async (
  add: boolean,
  connectionId: string,
  bearerToken: string,
) => {
  return await postJsonInvoke(
    `UpdateAppVersionSRGroup_v1?add=${add}&connection_id=${connectionId}&object_type=version_web_app`,
    {},
    bearerToken,
  );
};

export const invokeOrganizationContactsSRGroup = async (
  add: boolean,
  connectionId: string,
  orgCode: string,
  groupName: string,
  bearerToken: string,
) => {
  return await postJsonInvoke(
    `UpdateOrganizationGroupSRGroup_v1?add=${add}&connection_id=${connectionId}&org_code=${orgCode}&group_name=${groupName}`,
    {},
    bearerToken,
  );
};

/**
 *
 * @param {boolean} add whether or not to add the connection to the group
 * @param {string} connectionId
 * @param {string} bearerToken
 * @returns
 */
export const invokeOrganizationAdminSRGroup = async (
  add: boolean,
  connectionId: string,
  bearerToken: string,
) => {
  return await postJsonInvoke(
    `JoinOrgAdminSRGroup`,
    {
      connectionId: connectionId,
    },
    bearerToken,
  );
};
